<template>
  <span>
    <p
      class="boss-table-title is-boss-only-pc"
      data-test="label-company-name"
    >{{ entryCompanyName }}</p>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <approached-summary
          :approached-summaries="approachedSummaries"
        />
      </div>
    </div>
    <div class="boss-layout-block is-boss-only-pc">
      <div class="boss-layout boss-layout-start">
        <pdf-download :entry-ids="[entryId]" />
        <div>
          <button
            data-test="button-print-preview"
            class="boss-button"
            @click="windowOpenPrintPreview"
          >
            <img
              src="@/assets/images/icon-print.svg"
              alt
            >
            <span>印刷</span>
          </button>
        </div>
      </div>
    </div>
    <entry-detail-resume
      :entry-id="entryId"
      :entry-company-name="entryCompanyName"
      :is-simple-entry-form="isSimpleEntryForm"
    />
    <entry-detail-career-resume
      :entry-id="entryId"
      :entry-company-name="entryCompanyName"
      :is-simple-entry-form="isSimpleEntryForm"
    />
    <div class="pega-flex-center">
      <button
        class="boss-button boss-button-fill display-inline-flex"
        data-test="remove-button"
        @click="doRemove"
      >この応募者情報を削除する（復活不可）</button>
    </div>
  </span>
</template>

<script>
import EntryDetailResume from '@/components/organisms/EntryDetailResume'
import EntryDetailCareerResume from '@/components/organisms/EntryDetailCareerResume'
import ApproachedSummary from '@/components/molecules/ApproachedSummary'
import PdfDownload from '@/components/atoms/PdfDownload'

export default {
  components: {
    EntryDetailResume,
    EntryDetailCareerResume,
    ApproachedSummary,
    PdfDownload
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    entryCompanyName: {
      type: String,
      default: ''
    },
    isSimpleEntryForm: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      approachedSummaries: []
    }
  },
  watch: {
    entryId: {
      handler () {
        this.fetchApproachedSummary()
      }
    }
  },
  created () {
    this.fetchApproachedSummary()
  },
  methods: {
    fetchApproachedSummary () {
      this.$http.secured.get(`/entry/view/entries/${this.entryId}/approached_jobs`).then(response => {
        this.$set(this, 'approachedSummaries', response.data)
      })
    },
    windowOpenPrintPreview () {
      const routeData = this.$router.resolve({ name: 'entryPrintPreview', params: { entryId: this.entryId } })
      window.open(routeData.href, '_blank')
    },
    removeEntry () {
      return this.$http.secured.put(`/entry/view/entries/${this.entryId}/_closed`)
    },
    doRemove () {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeEntry() // 削除して
            .then(() => {
              this.$toasted.global.success({ message: '応募者情報を削除しました。' })
              this.$router.push({ name: 'entryTop' })
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
